import { useLocation, useNavigate } from "react-router";
import { Button } from "@gisce/oficina-virtual-components"
import { useTranslation } from "react-i18next"
import {
  Person,
  PersonAdd,
  AutoGraph,
  Savings,
} from "@mui/icons-material";
import { ContractationButtons } from "../../CustomItems/ContractationButtons";
import { useSettingsContext } from "@/components/Settings/hooks/useSettingsContext";
import { FC } from "react";

export const UpLg: FC = () => {

  const { t } = useTranslation();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const Settings = useSettingsContext();
  
  const navigateLogin = () => {
    if (Settings.features?.oidc) {
      navigate("/");
    } else {
      navigate(t("common:url.login"));
    }
  }

  return <>
    {Settings?.header?.variant === "horizontal" && <>

      {!Settings.features.oidc && pathname !== t('common:url.login') &&
        <Button
          variant="contained"
          onClick={() => navigateLogin()}
          startIcon={<Person />}
        >
          {t('common:text.login_title')}
        </Button>
      }

      {Settings.features?.signup &&
        pathname !== t('common:url.activate') &&
        !Settings.features?.oidc &&
        <Button
          variant="contained"
          onClick={() => navigate(t('common:url.activate'))}
          startIcon={<PersonAdd />}
        >
          {t('common:text.login_view_button_activate')}
        </Button>
      }

      {Settings.features?.unsignedContact && Settings.features?.contact &&
        <Button
          variant="contained"
          onClick={() => navigate(t('common:url.unsigned_contact'))}
        >
          {t('common:text.contact_title')}
        </Button>
      }

      {!Settings.contractation?.authenticate && <ContractationButtons />}

      {Settings?.comparator?.enabled &&
        pathname !== t('common:url.priceComparator') &&
        <Button
          variant="contained"
          onClick={() => navigate(t('common:url.priceComparator'))}
          startIcon={<Savings />}
        >
          {t('common:text.menu_price_comparator_title')}
        </Button>
      }

      {Settings?.comparator?.enabled &&
        pathname !== t('common:url.powerCalculator') &&
        <Button
          variant="contained"
          onClick={() => navigate(t('common:url.powerCalculator'))}
          startIcon={<AutoGraph />}
        >
          {t('common:text.menu_power_calculator_title')}
        </Button>
      }

    </>}
    
  </>
}
